@if (tableOfContents().length) {
    <aside class="sticky top-10 z-10 px-6 md:mt-40">
        <p class="font-base text-bold mb-5 font-heading">
            <strong>Overview:</strong>
        </p>
        <div class="overflow-y-auto">
            <ol
                class="relative list-none p-0 font-serif before:absolute before:bottom-0 before:left-2 before:top-px before:w-px before:border-l before:border-dashed before:border-[#d2d2d2] before:content-['']">
                @for (
                    heading of tableOfContents();
                    track heading.id;
                    let last = $last
                ) {
                    <li
                        routerLink="./"
                        [fragment]="heading.id"
                        class="group relative mb-6 flex cursor-pointer items-center last:mb-0 hover:text-link-blue">
                        <svg
                            width="62"
                            height="89"
                            viewBox="0 0 62 89"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            class="relative z-10 h-6 w-[18px]">
                            <path
                                class="transition duration-100 group-hover:fill-link-blue"
                                [ngClass]="
                                    activeFragment() == heading.id
                                        ? 'md:fill-darkgrey'
                                        : ''
                                "
                                d="M58.4399 30.1899C58.4399 14.9999 46.1299 2.68994 30.9399 2.68994C15.7499 2.68994 3.43994 14.9999 3.43994 30.1899C3.43994 34.6699 4.51994 38.8999 6.41994 42.6399L27.7899 84.0599C29.1099 86.6199 32.7799 86.6199 34.0999 84.0599L55.4699 42.6399C57.3699 38.8999 58.4499 34.6699 58.4499 30.1899H58.4399Z"
                                fill="#D2D2D2" />
                            <path
                                class="transition duration-100 group-hover:fill-link-blue"
                                [ngClass]="
                                    activeFragment() == heading.id
                                        ? 'md:fill-darkgrey'
                                        : ''
                                "
                                d="M30.9399 45.9901C39.5169 45.9901 46.4699 39.037 46.4699 30.4601C46.4699 21.8831 39.5169 14.9301 30.9399 14.9301C22.3629 14.9301 15.4099 21.8831 15.4099 30.4601C15.4099 39.037 22.3629 45.9901 30.9399 45.9901Z"
                                fill="white" />
                            <circle cx="31" cy="31" r="16" fill="white" />
                        </svg>

                        <div class="ml-2 flex-1">
                            <span
                                class="text-base font-light text-[#A8A8A8] group-hover:text-darkgrey">
                                {{ heading.text }}
                            </span>
                        </div>
                    </li>
                }
            </ol>
        </div>
    </aside>
}
